<!-- <div *ngIf="ballot"> -->
  <ion-button *ngIf="!ballot.boosted" (click)="boost(ballot)" id="boast-{{ballot.id}}"
    class="gradient__primary-secondary-135">
    <ion-icon slot="start" style="color: black" name="trending-up"></ion-icon>
      <span *ngIf="freeBoost==0">BOOST</span>
      <div *ngIf="freeBoost==0" class="boost-button">
        <img style="width: 18px;" src="/assets/icons/credits.png">
        <span>{{boostPrice}}</span>
      </div>

      <span style="margin-left: 5px; margin-right: 15px;" *ngIf="freeBoost>0">GRATIS</span>
      <ion-badge *ngIf="freeBoost>0" color="danger" shape="round" class="badge-top-left">{{this.freeBoost}}</ion-badge>
  </ion-button>

  <ion-button *ngIf="ballot.boosted" id="boast-{{ballot.id}}" class="gradient__primary-secondary-135 btn-tendenza">
    <ion-icon slot="start" style="color: black" name="trending-up"></ion-icon>
    <span>IN TENDENZA</span>
  </ion-button>
<!-- </div> -->